import { Image } from './Image';

// TODO: in v9, move styled() from Image.jsx to here
export var StyledImage = Image;